import React from 'react';
import PropTypes from 'prop-types';
import { IconSavedAd } from "../../../../Icon";
export var SavedAdNotificationCounter = function SavedAdNotificationCounter(_ref) {
  var notificationNumber = _ref.notificationNumber,
      className = _ref.className;

  if (notificationNumber > 0) {
    return /*#__PURE__*/React.createElement(IconSavedAd, {
      className: className,
      width: 18,
      height: 18
    });
  }

  return null;
};
SavedAdNotificationCounter.propTypes = process.env.NODE_ENV !== "production" ? {
  notificationNumber: PropTypes.number,
  className: PropTypes.string
} : {};
export default SavedAdNotificationCounter;
//# sourceMappingURL=SavedAdNotificationCounter.js.map